import { createSlice } from '@reduxjs/toolkit';
import { EmailTemplatesListStateType } from '../../types/emailTemplate';

const initialState: EmailTemplatesListStateType = {
    data: null,
    loading: false,
    error: false,
};
export const emailTemplatesListSlice = createSlice({
    name: 'emailTemplatesList',
    initialState,
    reducers: {
        getEmailTemplatesListFetch: (state) => {
            state.loading = true;
            state.error = false;
        },
        getEmailTemplatesListFetchSuccess: (state, action) => {
            state.data = action.payload;
            state.loading = false;
        },
        getEmailTemplatesListFetchFailure: (state, action) => {
            state.data = null;
            state.loading = false;
            state.error = true;
        },
    },
});

export const { getEmailTemplatesListFetch, getEmailTemplatesListFetchSuccess, getEmailTemplatesListFetchFailure } = emailTemplatesListSlice.actions;

export default emailTemplatesListSlice.reducer;
